import getLang from '../../../utils/getLang';
import { useLearningContentCardModels } from '../../cards/hooks/useLearningContentCardModels';
import { useRankedRecommendations } from './useRankedRecommendations';
export const useRankedRecommendationsContent = ({
  maxCards,
  inferenceSource,
  types = ['TRACK', 'LESSON', 'SHORT_FORM_CONTENT'],
  language = getLang(),
  skip
}) => {
  const {
    rankedRecommendations: recommendations,
    rankedRecommendationsLoading,
    rankedRecommendationsError,
    correlationId
  } = useRankedRecommendations({
    skip: !maxCards || skip,
    size: maxCards || 4,
    inferenceSource,
    types,
    language: language.toUpperCase()
  });

  // retrieves hydrated card models for the elements to render
  const {
    cardModels,
    cardModelsError,
    cardModelsLoading,
    apolloError: cardModelsApolloError
  } = useLearningContentCardModels({
    items: (recommendations === null || recommendations === void 0 ? void 0 : recommendations.map(({
      entityId,
      entityType
    }) => {
      return {
        id: entityId,
        type: entityType,
        language: language.toLowerCase()
      };
    })) || [],
    skip: !(recommendations !== null && recommendations !== void 0 && recommendations.length)
  });
  return {
    content: cardModels,
    loading: rankedRecommendationsLoading || cardModelsLoading || maxCards === undefined,
    error: rankedRecommendationsError || cardModelsError,
    apolloError: cardModelsApolloError,
    correlationId
  };
};